import { showToastrInfo, showToastrError, showToastrSuccess } from "../../util/toastr.js";
import { getSettings } from "../../store/configureStore";
import documentApi from "../../api/shared/documentApi";
import moment from "moment";

export default class FilesHelper {
    constructor(context, ownerId, loadTemplates, redirectAfterCommit) {
        this.context = context;
        this.ownerId = ownerId;
        this.container = "";
        this.templateContainer = "";
        this.redirectAfterCommit = redirectAfterCommit;
        this.listContent();

        if (loadTemplates)
            this.listTemplates();
    }

    beginSession() {
        const context = this.context;
        const ajaxActions = context.props.ajaxActions;

        ajaxActions.started();
        return documentApi.beginSession(this.ownerId, this.container)
            .then(response => {
                ajaxActions.ended();
                context.setState({ fileSessionId: response.data, hasUnsavedDocumentChanges: false });
                return {
                    success: true
                };
            })
            .catch(ex => {
                ajaxActions.failed();
                context.props.throwException(ex);

                context.setState({ fileSessionId: "no session", hasUnsavedDocumentChanges: false });

                return {
                    success: false,
                    data: ex //obsolete in most cases, error is handled completely here
                };
            });
    }

    commitSession() {
        const context = this.context;
        const ajaxActions = context.props.ajaxActions;

        if (!context.state.hasUnsavedDocumentChanges)
            return;

        ajaxActions.started();
        showToastrInfo("Even geduld. Bezig met het verwerken van de bestanden", true);
        documentApi.commitSession(this.context.state.fileSessionId, this.ownerId)
            .then(response => {
                ajaxActions.ended();

                if (response.status === 200) {
                    if (!this.redirectAfterCommit) {
                        //resets the session after the commit of the session
                        this.listContent();
                        context.setState({
                            fileSessionId: null,
                            createdOnDatesForFiles: null,
                            hasUnsavedDocumentChanges: false,
                            scrollToTop: true
                        });
                    }
                    showToastrSuccess("Het verwerken van de bestanden is gelukt", true);
                }
                else
                    showToastrError("Het verwerken van de bestanden is mislukt", true);
            })
            .catch(ex => {
                ajaxActions.failed();
                context.props.throwException(ex);
                showToastrError("Het verwerken van de bestanden is mislukt");

                return {
                    success: false,
                    data: ex
                };
            });
    }

    rollbackSession() {
        const context = this.context;
        const ajaxActions = context.props.ajaxActions;

        ajaxActions.started();
        documentApi.rollbackSession(context.state.fileSessionId)
            .then(response => {
                ajaxActions.ended();
                return {
                    success: true
                };
            })
            .catch(error => {
                ajaxActions.failed();
                context.props.throwException(error);

                return {
                    success: false,
                    data: error
                };
            });
    }

    listContent() {
        if (!this.context.state.fileSessionId) {
            this.beginSession(this.ownerId).then(result => {
                if (result.success)
                    this._getContentList();
            });
        } else
            this._getContentList();
    }

    clearIntervalObj(intervalId) {
        clearInterval(intervalId);
    }

    listContentWithoutCacheForPollingComponent(pollingProps) {
        const context = this.context;
        const ajaxActions = context.props.ajaxActions;

        let lowerComponentName = pollingProps.componentName.toLowerCase();

        documentApi.listContentWithoutCache(this.ownerId, this.container, lowerComponentName)
            .then(response => {
                let fileComponents = this.context.state.fileComponents;
                let createdOnDatesForFiles = this.context.state.createdOnDatesForFiles;

                // enkel componentFolder voor betrokken component updaten
                let componentFolder = response.data.find(d => d.name.toLowerCase() === lowerComponentName);
                if (componentFolder) { //check of componentFolder reeds is aangemaakt.
                    fileComponents = Object.assign(fileComponents, { [componentFolder.name.toLowerCase()]: componentFolder.files.map(f => f.name) });
                    createdOnDatesForFiles = Object.assign(createdOnDatesForFiles, { [componentFolder.name.toLowerCase()]: componentFolder.files.map(f => moment(f.createdOn).format("DD/MM/YYYY HH:mm")) });

                    if (componentFolder.files.length >= pollingProps.minFiles) {
                        // interval stoppen en documenten updaten
                        let stateIntervalCounterName = this.getIntervalCounterName(lowerComponentName);
                        let stateIntervalCounter = this.context.state[stateIntervalCounterName];
                        stateIntervalCounter = Object.assign(stateIntervalCounter, { counter: pollingProps.pollTimes + 1 });

                        this.clearIntervalObj(stateIntervalCounter.interval);

                        this.context.setState({
                            [stateIntervalCounterName]: stateIntervalCounter,
                            fileComponents: fileComponents,
                            createdOnDatesForFiles: createdOnDatesForFiles
                        });
                    }
                    else {
                        // documenten updaten
                        this.context.setState({
                            fileComponents: fileComponents,
                            createdOnDatesForFiles: createdOnDatesForFiles
                        });
                    }
                }
                return {
                    success: true
                };
            })
            .catch(error => {
                ajaxActions.failed();
                context.props.throwException(error);

                return {
                    success: false,
                    data: error //obsolete in most cases, error is handled completely here
                };
            });
    }

    getBaseFileLocation() {
        return this.container.split("$").join("/");
    }

    getFileDownloadUrl() {
        return documentApi.getFileDownloadUrl(this.context.state.fileSessionId);
    }

    getTemplateDownloadUrl() {
        return documentApi.getTemplateDownloadUrl(this.templateContainer);
    }

    _getContentList() {
        const context = this.context;
        const ajaxActions = context.props.ajaxActions;

        ajaxActions.started();
        documentApi.listContent(context.state.fileSessionId)
            .then(response => {
                ajaxActions.ended();

                let fileComponents = {};
                let createdOnDatesForFiles = {};
                response.data.forEach((componentFolder) => {
                    fileComponents = Object.assign(fileComponents, this.getFormattedComponentFolder(componentFolder));
                    createdOnDatesForFiles = Object.assign(createdOnDatesForFiles, this.getCreatedOnDatesForFiles(componentFolder));
                });

                context.setState({ fileComponents: fileComponents, createdOnDatesForFiles: createdOnDatesForFiles });

                return {
                    success: true
                };
            })
            .catch(ex => {
                ajaxActions.failed();
                context.props.throwException(ex);

                return {
                    success: false
                };
            });
    }

    getFormattedComponentFolder(componentFolder) {
        const lowerComponentName = componentFolder.name.toLowerCase();

        if (componentFolder.files.length > 0) {
            return { [lowerComponentName]: componentFolder.files.map(f => f.name) };
        }

        if (componentFolder.folders.length > 0) {
            let result = {};
            componentFolder.folders.forEach(folder => result[lowerComponentName + "/" + folder.name] = folder.files.map(f => f.name));
            return result;
        }

        return { [lowerComponentName]: componentFolder.files.map(f => f.name) };
    }

    getCreatedOnDatesForFiles(componentFolder) {
        const lowerComponentName = componentFolder.name.toLowerCase();

        if (componentFolder.files.length > 0) {
            return { [lowerComponentName]: componentFolder.files.map(f => moment(f.createdOn).format("DD/MM/YYYY HH:mm")) };
        }

        if (componentFolder.folders.length > 0) {
            let result = {};
            componentFolder.folders.forEach(folder => result[lowerComponentName + "/" + folder.name] = folder.files.map(f => moment(f.createdOn).format("DD/MM/YYYY HH:mm")));
            return result;
        }

        return { [lowerComponentName]: componentFolder.files.map(f => moment(f.createdOn).format("DD/MM/YYYY HH:mm")) };
    }

    listTemplates() {
        const context = this.context;
        const ajaxActions = context.props.ajaxActions;

        //todo load this async on application startup?
        ajaxActions.started();

        context.setState({ templateComponents: {} });

        documentApi.listTemplates(this.templateContainer)
            .then(response => {
                ajaxActions.ended();

                let templateComponents = {};
                response.data.forEach((componentFolder) => {
                    templateComponents = Object.assign(templateComponents, { [componentFolder.name.toLowerCase()]: componentFolder.files.map(f => f.name) });
                });

                context.setState({ templateComponents: templateComponents });

                return {
                    success: true
                };
            })
            .catch(ex => {
                ajaxActions.failed();
                context.props.throwException(ex);

                return false;
            });
    }

    uploadFiles(component, files) {
        files.forEach(file => this.uploadOneFile(component, file));
    }

    uploadOneFile(component, file) {
        let notAllowedCharacters = ["“", "#", "%", "&", "*", ":", "<", ">", "'", "?", "\\", "/", "{", "|", "}", "~"];
        let cancelOnNotAllowedCharacters = false;
        let illegalCharactersCount = 0;
        const lowerComponentName = component.toLowerCase();

        notAllowedCharacters.forEach(char => {
            if (file.name.indexOf(char) >= 0) {
                cancelOnNotAllowedCharacters = true;
                illegalCharactersCount++;
            }
        });

        if (illegalCharactersCount != 0) {
            showToastrError("Bestandsnamen met volgende tekens kunnen niet opgeladen worden. " + notAllowedCharacters.join(" "));
            return;
        }

        if (file.size > getSettings().maxAllowedContentLength) {
            showToastrError("Het '" + file.name + "' bestand is te groot. Maximum 100MB per bestand.");
            return;
        }

        if (this.context.state.fileComponents[lowerComponentName]) {
            let files = this.context.state.fileComponents[lowerComponentName];

            if (files.find(x => x === file.name) && !confirm("Wil je het " + file.name + " bestand overschrijven?"))
                return;
        }

        if (!this.context.state.fileSessionId) {
            this.beginSession(this.ownerId).then(result => {
                if (result.success)
                    this._uploadTheFile(lowerComponentName, file);
            });
        } else {
            this._uploadTheFile(lowerComponentName, file);
        }
    }

    _uploadTheFile(component, file) {
        const context = this.context;
        const ajaxActions = context.props.ajaxActions;

        let data = new FormData();
        data.append(1, file);

        ajaxActions.started();
        const formattedComponentName = component.toLowerCase().replace("/", "$");
        documentApi.uploadFiles(this.context.state.fileSessionId, formattedComponentName, data)
            .then(response => {
                this.handleUploadOneFileResult(response, component, file);
                ajaxActions.ended();
                //onderstaande toastr staat in commentaar omdat de toastrs bij bewaren boven moeten worden getoond omdat er dan ook naar boven wordt gescrolled en dit is niet mogelijk zolang er onder nog een toastr staat. Is met Mieke en Lieve besproken.
                //showToastrInfo(file.name + " is toegevoegd");
                return {
                    success: true
                };
            })
            .catch(ex => {
                ajaxActions.failed();
                context.props.throwException(ex);

                return {
                    success: false,
                    data: ex //obsolete in most cases, error is handled completely here
                };
            });
    }

    _deleteTheFile(component, fileName) {
        const context = this.context;
        const ajaxActions = context.props.ajaxActions;

        ajaxActions.started();
        const formattedComponentName = component.toLowerCase().replace("/", "$");
        documentApi.deleteFile(this.context.state.fileSessionId, formattedComponentName, fileName)
            .then(response => {
                ajaxActions.ended();
                this.handleDeleteOneFileResult(response, component, fileName);
                return {
                    success: true
                };
            })
            .catch(error => {
                ajaxActions.failed();
                context.props.throwException(error);

                return {
                    success: false,
                    data: error
                };
            });
    }

    deleteOneFile(component, fileName) {
        if (!this.context.state.fileSessionId) {
            this.beginSession(this.ownerId).then(result => {
                if (result.success)
                    this._deleteTheFile(component, fileName);
            });
        } else {
            this._deleteTheFile(component, fileName);
        }
    }

    handleUploadOneFileResult(result, componentName, file) {
        if (result.status == 200) {
            const lowerComponentName = componentName.toLowerCase();

            let fileComponents = Object.assign({}, this.context.state.fileComponents ? this.context.state.fileComponents : {});
            if (!fileComponents[lowerComponentName])
                fileComponents[lowerComponentName] = [];

            let componentFiles = fileComponents[lowerComponentName];
            componentFiles = componentFiles.filter(x => x !== file.name);
            componentFiles.push(file.name);
            fileComponents[lowerComponentName] = componentFiles;

            this.context.setState(
                {
                    fileComponents: fileComponents,
                    hasUnsavedChanges: true, // check if relevant
                    hasUnsavedDocumentChanges: true
                });
        } else {
            showToastrError("De upload van " + file.name + " is mislukt");
        }
    }

    handleDeleteOneFileResult(result, component, fileName) {
        if (result.status == 200) {
            const lowerComponentName = component.toLowerCase();
            let fileComponents = Object.assign({}, this.context.state.fileComponents);
            let componentFiles = fileComponents[lowerComponentName];
            fileComponents[lowerComponentName] = componentFiles.filter(x => x != fileName);

            this.context.setState(
                {
                    fileComponents: fileComponents,
                    hasUnsavedChanges: true,
                    hasUnsavedDocumentChanges: true
                });
        } else {
            showToastrError("Verwijderen van bestand " + fileName + " is mislukt");
        }
    }

    startPolling(pollingProps) {
        if (pollingProps.pollingEnabled) {
            const pollTimes = pollingProps.pollTimes;
            const lowerComponentName = pollingProps.componentName.toLowerCase();
            const stateIntervalCounterName = this.getIntervalCounterName(lowerComponentName);

            const stateIntervalCounter = {
                counter: 1,
                interval: setInterval(() => {
                    let self = this;

                    if (this.context.state[stateIntervalCounterName].counter <= pollTimes) {
                        let stateIntervalCounterName = this.getIntervalCounterName(lowerComponentName);
                        let stateIntervalCounter = this.context.state[stateIntervalCounterName];
                        stateIntervalCounter = Object.assign(stateIntervalCounter, { counter: stateIntervalCounter.counter + 1 });

                        this.context.setState({ [stateIntervalCounterName]: stateIntervalCounter });
                        self.context.filesHelper.listContentWithoutCacheForPollingComponent(pollingProps, useRootContainer);
                    }
                    else {
                        this.clearIntervalObj(this.context.state[stateIntervalCounterName].interval);
                    }
                }, 10000)
            };

            let fileComponents = this.context.state.fileComponents;
            let createdOnDatesForFiles = this.context.state.createdOnDatesForFiles;

            fileComponents[lowerComponentName] = [];
            createdOnDatesForFiles[lowerComponentName] = [];

            let useRootContainer = false;
            if (lowerComponentName === "pdf")
                useRootContainer = true;

            this.context.setState({
                fileComponents: fileComponents,
                [stateIntervalCounterName]: stateIntervalCounter,
                createdOnDatesForFiles: createdOnDatesForFiles
            });
        }
    }

    isPollingDocument(componentName, maxPollTimes) {
        const stateIntervalCounterName = this.getIntervalCounterName(componentName.toLowerCase());
        if (this.context.state[stateIntervalCounterName] === undefined || this.context.state[stateIntervalCounterName].counter === undefined)
            return false;
        else
            return this.context.state[stateIntervalCounterName].counter <= maxPollTimes;
    }

    getIntervalCounterName(componentName) {
        return componentName + "_intervalCounter";
    }

    stopActiveInterval() {
        if (this.context.state)
            Object.keys(this.context.state).filter(x => x.match('_interval')).forEach(x => this.clearIntervalObj(this.context.state[x]));
    }
}
